export default class NotificationProvider {
  show(ref, options) {
    ref.current && ref.current.addNotification({
      title: options.title,
      message: options.message,
      type: options.type,
      insert: "top",
      container: "top-right",
      animationIn: ["animated", "slideInRight", "faster"],
      slidingEnter: {duration: 250},
      slidingExit: {duration: 250},
      animationOut: ["animated", "slideOutRight", "faster"],
      dismiss: { duration: 5000 },
      dismissable: { click: true }
    });

  }

}
